import React from 'react';
import { User, Mail, Shield, Building2 } from 'lucide-react';

const roleColor = (role) => {
  if (role === 'SuperAdmin')  return { bg: '#fef3c7', color: '#92400e' };
  if (role === 'ClientAdmin') return { bg: '#dbeafe', color: '#1e40af' };
  return { bg: '#f0fdf4', color: '#166534' };
};

const UserProfile = ({ user }) => {
  return (
    <div style={{ padding: '2rem', maxWidth: '500px', margin: '0 auto' }}>
      <h2 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '1.5rem', color: '#111827' }}>
        My Profile
      </h2>

      <div style={{
        background: 'var(--theme-surface)',
        border: '1px solid #e5e7eb',
        borderRadius: '0.75rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        overflow: 'hidden',
      }}>
        {/* Avatar header */}
        <div style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '2rem',
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
        }}>
          <div style={{
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.25)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <User size={32} color="#fff" />
          </div>
          <div>
            <div style={{ color: '#fff', fontWeight: '700', fontSize: '1.2rem' }}>
              {user?.username || 'Unknown'}
            </div>
            <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.85rem' }}>
              {user?.email || '—'}
            </div>
          </div>
        </div>

        {/* Details */}
        <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
            <User size={18} style={{ color: '#9ca3af', marginTop: '2px' }} />
            <div>
              <div style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Username</div>
              <div style={{ fontSize: '0.95rem', color: '#111827', marginTop: '0.2rem' }}>{user?.username || '—'}</div>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
            <Mail size={18} style={{ color: '#9ca3af', marginTop: '2px' }} />
            <div>
              <div style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Email</div>
              <div style={{ fontSize: '0.95rem', color: '#111827', marginTop: '0.2rem' }}>{user?.email || '—'}</div>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
            <Shield size={18} style={{ color: '#9ca3af', marginTop: '2px' }} />
            <div>
              <div style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Roles</div>
              <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap', marginTop: '0.4rem' }}>
                {(user?.roles || []).length > 0 ? (user.roles).map(r => {
                  const c = roleColor(r);
                  return (
                    <span key={r} style={{
                      padding: '0.2rem 0.65rem',
                      borderRadius: '9999px',
                      fontSize: '0.8rem',
                      fontWeight: '600',
                      background: c.bg,
                      color: c.color,
                    }}>{r}</span>
                  );
                }) : <span style={{ color: '#9ca3af', fontSize: '0.875rem' }}>No roles assigned</span>}
              </div>
            </div>
          </div>

          {user?.establishment_name && (
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
              <Building2 size={18} style={{ color: '#9ca3af', marginTop: '2px' }} />
              <div>
                <div style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Organization</div>
                <div style={{ fontSize: '0.95rem', color: '#111827', marginTop: '0.2rem', fontWeight: '500' }}>{user.establishment_name}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
